<template>
    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div class="kt-portlet kt-portlet--mobile">
            <div class="kt-portlet__head kt-portlet__head--lg no-border-radius">
                <div class="kt-portlet__head-label">
                    <div class="row center">
                        <Dropdown v-model="selectedOrg" :options="organizations" optionLabel="display_name"
                                  placeholder="Organização" class="auto-center" :dataKey="'id'" :filter="true"
                                  @input="saveChosenOptionsToLocalStorage" style="width: 250px">
                            <template #option="slotProps" style="width: 500px">
                                <div v-if="loadingOrgs"> {{ $t('AppImplement.Carregando, aguarde') }}</div>
                                <div style="padding-right: 20px" v-else-if="slotProps.option.name === 'ND'">
                                    -
                                </div>
                                <div style="padding-right: 20px" v-else>
                                    {{ slotProps.option.display_name }}
                                </div>
                            </template>
                        </Dropdown>
                    </div>
                </div>
            </div>
            <div v-if="!selectedOrg" class="row justify-content-center">
                <div class="col-10 col-md-6 no-org-selected">
                    <span>{{ $t('AppImplement.Selecione uma organização para carregar os dados') }}</span>

                </div>
            </div>
            <div v-else class="kt-portlet__body no-padding" id="tableDiv">
                <div class="card data-table-width">
                    <app-implement-table :loading="loading" :grid-data="gridData" :selected-org="selectedOrg"
                                         @scrollUp="scrollUp" @edit="edit" @add="add" @remove="remove" @view="view"/>
                </div>
            </div>

            <app-implement-view-dialog :implement="selectedImplement" :show-dialog="showViewDialog"
                                       @closeDialog="closeViewDialog"/>

            <Dialog :visible.sync="showRemoveDialog" modal>
                <template #header>
                    <div style="font-size: larger; font-weight: bold" class="pl-3 dialog-size">
                        {{ $t('AppImplement.Atenção!') }}
                    </div>
                </template>
                <ProgressSpinner v-if="loadingRequest" style="height: 40px"
                                 class="mt-4 mb-4 d-flex align-items-center justify-content-center"/>
                <div v-else class="d-flex flex-column align-items-center dialog-size" style="font-size: 1.2rem">
                    {{ $t('AppImplement.Tem certeza que deseja remover este implemento?') }}
                </div>
                <template #footer>
                    <Button :disabled="loadingRequest" :label="$t('AppImplement.Não')" @click="closeRemoveDialog"
                            class="p-button-secondary"/>
                    <Button :disabled="loadingRequest" :label="$t('AppImplement.Sim')" @click="removeImplement" class="p-button-info"/>
                </template>
            </Dialog>
        </div>
    </div>
</template>

<script>
import Dropdown from "primevue/dropdown";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import ProgressSpinner from "primevue/progressspinner";
import OrganizationsService from "@/services/OrganizationsService";
import ImplementsService from "@/services/ImplementsService";
import orderCustomFieldByNaturalOrder from "@/mixins/ArrayMixin";
import AppImplementTable from "@/components/views/implements/AppImplementTable";
import AppImplementViewDialog from "@/components/views/implements/AppImplementViewDialog";
import {router} from "@/router";
export default {
    mixins: [orderCustomFieldByNaturalOrder],
    components: {
        Dropdown,
        Dialog,
        Button,
        ProgressSpinner,
        AppImplementTable,
        AppImplementViewDialog
    },
    created() {
        this.organizationsService = new OrganizationsService();
        this.implementsService = new ImplementsService();
    },
    mounted: function () {
        this.getOrganizations();
    },
    data() {
        return {
            implementsService: null,
            organizationsService: null,
            organizations: [],
            selectedOrg: null,
            loadingOrgs: false,
            gridData: [],
            loading: false,
            loadingRequest: false,
            selectedImplement: {},
            showViewDialog: false,
            showRemoveDialog: false
        }
    },
    methods: {
        getOrganizations() {
            this.loadingOrgs = true;
            this.organizationsService.getAllV3('ORGANIZATION_IMPLEMENTS').then((results) => {
                this.populateOrgsList(results);
                this.loadFilteredOptions();
            }).catch(() => {
                this.showErrorToast(this.$t('AppImplement.Não foi possivel buscar as organizações'))
            }).finally(() => {
                this.loadingOrgs = false;
            })
        },
        populateOrgsList(orgs) {
            this.organizations = this.orderCustomFieldByNaturalOrder(orgs, "name");
        },
        loadFilteredOptions() {
            this.storedChosenOptions = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS));
            if (!this.storedChosenOptions || !this.storedChosenOptions.clients || this.storedChosenOptions.clients.length === 0) {
                this.storedChosenOptions = {};
                return;
            }
            this.selectedOrg = this.storedChosenOptions['clients'].filter(a => this.organizations.some(b => a.id === b.id))[0];
        },
        saveChosenOptionsToLocalStorage() {
            this.storedChosenOptions['clients'] = [this.selectedOrg];
            localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS, JSON.stringify(this.storedChosenOptions));
        },
        add() {
            router.push({name: 'new-implement', query: {org_id: this.selectedOrg.id}});
        },
        edit(value) {
            this.selectedImplement = value
            router.push({name: 'edit-implement', query: {org_id: this.selectedOrg.id, implement_id: value.id}});
        },
        view(value) {
            this.selectedImplement = value
            this.showViewDialog = true
        },
        closeViewDialog() {
            this.showViewDialog = false
        },
        remove(value) {
            this.selectedImplement = value
            this.showRemoveDialog = true
        },
        removeImplement() {
            this.loadingRequest = true
            this.implementsService.removeImplement(this.selectedImplement.id)
                .then(() => {
                    this.showSuccessToast(this.$t('AppImplement.Implemento removido com sucesso'))
                    this.getAllImplementsByOrg()
                    this.closeRemoveDialog()
                })
                .catch(error => {
                    if (error.response && error.response.status === 400) {
                        this.showErrorToast(this.$t('AppImplementForm.Implemento está vinculado ao veículo, desvincule antes de removê-lo'))
                        return;
                    }
                    this.showErrorToast(this.$t('AppImplement.Não foi possivel remover o implemento'))
                })
                .finally(() => {
                    this.loadingRequest = false
                })
        },
        closeRemoveDialog() {
            this.showRemoveDialog = false
        },
        scrollUp() {
            scrollTo(0, 0)
        },
        getAllImplementsByOrg() {
            this.loading = true
            this.implementsService.getImplementsByOrgV3(this.selectedOrg.id)
                .then((response) => {
                    this.gridData = response.sort((a, b) => a.identification.localeCompare(b.identification));
                })
                .catch(error => {
                    console.log(error)
                    if (error.response && error.response.status === 403) {
                        this.showErrorToast(this.$t('AppImplement.Você não tem acesso a esssa funcionalidade'))
                        return;
                    }
                    this.showErrorToast(this.$t('AppImplement.Não foi possivel completar a operação, tente novamente'))
                }).finally(() => {
                this.loading = false;
            });
        },
        showSuccessToast(message) {
            this.$toast.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: message,
                life: 3000
            });
        },
        showErrorToast(message) {
            this.$toast.add({
                severity: 'error',
                summary: 'Erro',
                detail: message,
                life: 3000
            });
        }
    },
    watch: {
        selectedOrg: function () {
            this.getAllImplementsByOrg()
        }
    }
}
</script>


<style scoped lang="scss">
@import "src/assets/styles/primevue";
.no-org-selected {
    font-size: x-large;
    margin: 1.3rem;
    background-color: #fff;
    border-radius: 0.5rem;
    height: 10rem;
    display: flex;
    justify-content: center;
    align-items: center;
}
.dialog-size {
    width: 25vw;
}
@media (max-width: 758px) {
    .dialog-size {
        width: 60vw;
    }
}
@media (max-width: 1024px) and (min-width: 758px) {
    .dialog-size {
        width: 50vw;
    }
}
</style>
